import { createContext } from "react"
import type { tutorials } from "~/lib/tutorials"

const initialContext = {
	onboardingSession: undefined as string | undefined,
	beginOnboarding: () => false,
	endOnboarding: () => {},
	resetDiscovery: () => {},
	ready: false,
	allowAutomatic: false,
	busy: false,
	blocked: false,
	pending: undefined as
		| {
				id: keyof typeof tutorials
				source: "manual" | "welcome" | "announcement"
				destination?: string
		  }
		| undefined,
	announcement: undefined as keyof typeof tutorials | undefined,
	start: (
		_id: keyof typeof tutorials,
		_source: "manual" | "welcome" | "announcement" = "manual",
		_destination?: string
	) => false,
	claim: (_owner: symbol) => false,
	release: (_owner: symbol) => {},
	closeAnnouncement: (_id: keyof typeof tutorials) => {},
	acknowledgeAnnouncement: async (
		_id: keyof typeof tutorials,
		_outcome: "completed" | "dismissed"
	) => {}
}

export const TutorialContext = createContext(initialContext)
